export default __webpack_public_path__ + "static/media/cc-mastercard.81af2c94.svg";